import { render, staticRenderFns } from "./ColouredSquare.vue?vue&type=template&id=f278ba6e&"
import script from "./ColouredSquare.vue?vue&type=script&lang=js&"
export * from "./ColouredSquare.vue?vue&type=script&lang=js&"
import style0 from "./ColouredSquare.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports